import { IPatientNote } from '@pia/pia.shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { PatientNotesChannel } from 'src/app/business/patientNotes/contracts/patientNotes-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { PatientNoteModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class PatientNoteSyncService extends SyncService<IPatientNote> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IPatientNote>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(PatientNoteModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return (
      channel === PatientNotesChannel.CREATE ||
      channel === PatientNotesChannel.EDIT ||
      channel === PatientNotesChannel.DELETE
    );
  }
}
